import React from "react";
import PropTypes from "prop-types";
import PetalInfo from "./PetalInfo";
import LollipopPetal from "../models/LollipopPetal";
import Track from "../../../models/Track";

function PetalTitle({ item, track }) {
  return item ? <PetalInfo track={track} petal={item} /> : null;
}

PetalTitle.propTypes = {
  item: PropTypes.instanceOf(LollipopPetal).isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
};

export default PetalTitle;
